/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-06 11:04:16
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-02-22 16:52:20
 */
export default {
    phone:/^1[0-9]{10}$/,
    // idCard:/^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    idCard:/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
};



// WEBPACK FOOTER //
// ./src/utils/pattern.js